import { useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { ApiError } from "../../../../../models";
import { SaveEmailForNewsletter } from "../../../../../services";
import { PDLButton, PDLTypography } from "../../../dna";
import "./index.scss";

const HomeNewsletter = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    setSuccessMessage(null);
    setErrorMessage(null);

    if (!email) {
      setErrorMessage("Informe um e-mail válido.");
      return;
    }

    try {
      setIsLoading(true);

      await SaveEmailForNewsletter({ email: email.trim() });

      setSuccessMessage("E-mail salvo, entraremos em contato!");
      setEmail("");
    } catch (error) {
      const errorMsg =
        (error as ApiError)?.response?.data?.message ||
        "Não foi possível cadastrar seu e-mail. Tente novamente.";

      setErrorMessage(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className="pdl_component_home_newsletter">
      <Row>
        <Col xs={12} sm={6} lg={4} className="mx-auto">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col className="text-center mb-5">
                <PDLTypography as="h2" display size="md" weight="semibold">
                  Receba nossa Newsletter gratuitamente
                </PDLTypography>
              </Col>
            </Row>

            <Row className="d-flex flex-row flex-nowrap align-items-start pb-1">
              <Col className="ps-0">
                <Form.Control
                  type="email"
                  placeholder="Insira seu e-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isLoading}
                />
                <div className="feedback-message-container">
                  {successMessage && (
                    <Row className="mt-1">
                      <Col className="ps-0">
                        <PDLTypography size="xs" variant="success">
                          {successMessage}
                        </PDLTypography>
                      </Col>
                    </Row>
                  )}

                  {errorMessage && (
                    <Row className="mt-1">
                      <Col className="ps-0">
                        <PDLTypography size="xs" variant="danger">
                          {errorMessage}
                        </PDLTypography>
                      </Col>
                    </Row>
                  )}
                </div>
              </Col>

              <Col className="pe-0 col-sm-auto">
                <PDLButton type="submit" variant="primary" disabled={isLoading}>
                  {isLoading ? "Enviando..." : "Cadastre-se na Newsletter"}
                </PDLButton>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col className="ps-0">
                <PDLTypography size="sm">
                  Nós cuidamos dos seus dados na nossa{" "}
                  <a href="/privacidade">política de privacidade</a>.
                </PDLTypography>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default HomeNewsletter;
